import { ScrollablePane, ScrollbarVisibility, SelectionMode, Sticky, StickyPositionType } from '@fluentui/react';
import { PanelType, TooltipHost } from 'office-ui-fabric-react';
import { CommandBar } from 'office-ui-fabric-react/lib/CommandBar';
import { DetailsHeader } from 'office-ui-fabric-react/lib/components/DetailsList/DetailsHeader';
import { ColumnActionsMode, DetailsList, DetailsRow, Selection } from 'office-ui-fabric-react/lib/DetailsList';
import React, { Component } from 'react';
import { DataCompteMandatOperationNiveauAlerte } from '../../data/DataCompteMandatOperationNiveauAlerte';
import { DataMandat } from '../../data/DataMandat.jsx';
import { NIVEAUX_ALERTES } from '../../data/DataNiveauAlerte';
import { Immocom } from '../../specifique/immocom';
import { EUIPanel } from '../EUI/EUIPanel';
import { EUIToggle } from '../EUI/EUIToggle';
import { ProgressIndicatorChargement } from '../Loader/ProgressIndicatorChargement';
import { MessageBars } from '../Outils/MessageBars';

export class FicheMandatAlerte extends Component {

    static defaultProps = {
        isOpen: false,
        loginCompte: undefined,
        onDismiss: () => null,
    };

    static defaultState = {
        items: [],
    };

    constructor(props) {
        super(props);
        this.state = { ...FicheMandatAlerte.defaultState };
        this._columns = this._getColumns();
        this._selection = new Selection();
    };

    _chargementDonnees = () => {

        const { loginCompte } = this.props;
        if (loginCompte) {

            this.setState({
                enCoursDeTraitement: true,
                messageEnCoursTraitement: "Chargement des alertes en cours"
            });

            DataMandat._chargementMandatAlerte(loginCompte).then(responseFetch => {
                const retourVerif = Immocom.onRegardeSiOnChargeLesDonnees(responseFetch, this);
                if (retourVerif === null) {

                    let items = responseFetch.reponseAPIobjet;
                    const shouldBeChecked = (array, typeAlerte) => {
                        return array.every(niveauALerte => niveauALerte[typeAlerte] === "1") ? "1" : "0";
                    };

                    const rowZero = {
                        idOperation: 0,
                        nomCommercial: "Toutes les alertes",
                        option: shouldBeChecked(items, "option"),
                        leveeOption: shouldBeChecked(items, "leveeOption"),
                        reservation: shouldBeChecked(items, "reservation"),
                        desistement: shouldBeChecked(items, "desistement"),
                        dedoublementContact: shouldBeChecked(items, "dedoublementContact"),
                        envoiDocument: shouldBeChecked(items, "envoiDocument"),
                        echeanceOption: shouldBeChecked(items, "echeanceOption"),
                        gestionDocument: shouldBeChecked(items, "gestionDocument"),
                        option: shouldBeChecked(items, "option"),
                        leveeOption: shouldBeChecked(items, "leveeOption"),
                        reservation: shouldBeChecked(items, "reservation"),
                        desistement: shouldBeChecked(items, "desistement"),
                        dedoublementContact: shouldBeChecked(items, "dedoublementContact"),
                        envoiDocument: shouldBeChecked(items, "envoiDocument"),
                        echeanceOption: shouldBeChecked(items, "echeanceOption"),
                        gestionDocument: shouldBeChecked(items, "gestionDocument"),
                        signaturesClients: shouldBeChecked(items, "signaturesClients"),
                        aSignerEiffage: shouldBeChecked(items, "aSignerEiffage"),
                        signerEiffage: shouldBeChecked(items, "signerEiffage"),
                        modifierContact: shouldBeChecked(items, "modifierContact"),
                        messageInstantane: shouldBeChecked(items, "messageInstantane"),
                    };

                    items.unshift(rowZero);
                    Immocom.onReinitStateValeurParDefautEtExecutionDuSetState(this, { items });
                }
                else Immocom.onTraitementErreurAvecState(this, {}, retourVerif, responseFetch);
            });
        }
        else {
            const state = { items: [] };
            Immocom.onReinitStateValeurParDefautEtExecutionDuSetState(this, state);
        }

    };

    _disableAll = (idAlerte) => {

        this.setState({
            enCoursDeTraitement: true,
            messageEnCoursTraitement: "Désactivation des alertes en cours"
        });

        const { loginCompte } = this.props;
        DataCompteMandatOperationNiveauAlerte._onSuppressionCompteMandatOperationNiveauAlerteGlobale(loginCompte, idAlerte).then(responseFetch => {
            const retourVerif = Immocom.onRegardeSiOnChargeLesDonnees(responseFetch, this);
            if (retourVerif === null) this._chargementDonnees();
            else Immocom.onTraitementErreurAvecState(this, {}, retourVerif, responseFetch);
        });

    };

    _disableOne = (idOperation, idAlerte) => {

        this.setState({
            enCoursDeTraitement: true,
            messageEnCoursTraitement: "Désactivation de l'alerte en cours"
        });

        const { loginCompte } = this.props;
        DataCompteMandatOperationNiveauAlerte._onSuppresionCompteMandatOperationNiveauAlerte(loginCompte, idOperation, idAlerte).then(responseFetch => {
            const retourVerif = Immocom.onRegardeSiOnChargeLesDonnees(responseFetch, this);
            if (retourVerif === null) this._chargementDonnees();
            else Immocom.onTraitementErreurAvecState(this, {}, retourVerif, responseFetch);
        });

    };

    _enableAll = (idAlerte) => {

        this.setState({
            enCoursDeTraitement: true,
            messageEnCoursTraitement: "Activation des alertes en cours"
        });

        const { loginCompte } = this.props;
        DataCompteMandatOperationNiveauAlerte._onEnregistrementCompteMandatOperationNiveauAlerteGlobale(loginCompte, idAlerte).then(responseFetch => {
            const retourVerif = Immocom.onRegardeSiOnChargeLesDonnees(responseFetch, this);
            if (retourVerif === null) this._chargementDonnees();
            else Immocom.onTraitementErreurAvecState(this, { ...this.state }, retourVerif, responseFetch);
        });

    };

    _enableOne = (idOperation, idAlerte) => {

        this.setState({
            enCoursDeTraitement: true,
            messageEnCoursTraitement: "Activation de l'alerte en cours"
        });

        const { loginCompte } = this.props;
        DataCompteMandatOperationNiveauAlerte._onEnregistrementCompteMandatOperationNiveauAlerte(loginCompte, idOperation, idAlerte).then(responseFetch => {
            const retourVerif = Immocom.onRegardeSiOnChargeLesDonnees(responseFetch, this);
            if (retourVerif === null) this._chargementDonnees();
            else Immocom.onTraitementErreurAvecState(this, {}, retourVerif, responseFetch);
        });

    };

    _getColumns = () => {

        const buildColumn = (key, name, title) => {
            return {
                columnActionsMode: ColumnActionsMode.disabled,
                isResizable: true,
                key,
                minWidth: 40,
                maxWidth: 40,
                name,
                onRender: (item) => <EUIToggle
                    ariaLabel={title}
                    checked={item[key] === "1"}
                    disabled={item[`${key}_disabled`] === "0"}
                    onChange={(event, checked) => this._toggleAlerte(item.idOperation, NIVEAUX_ALERTES[key], checked)}
                    onText=""
                    offText=""
                    title={title}
                />
            };
        };

        return [
            {
                columnActionsMode: ColumnActionsMode.disabled,
                fieldName: 'nomCommercial',
                isResizable: true,
                key: 'nomCommercial',
                name: 'Opération',
            },
            buildColumn("option", "Option", "Alerte sur option"),
            buildColumn("leveeOption", "Levée option", "Alerte sur levée d'option"),
            buildColumn("reservation", "Réservation", "Alerte sur réservation"),
            buildColumn("desistement", "Désistement", "Alerte sur désistement"),
            buildColumn("envoiDocument", "Envoi document", "Alerte sur envoi document"),
            buildColumn("dedoublementContact", "Dédoublement contact", "Alerte sur dédoublement contact"),
            buildColumn("echeanceOption", "Echéance option", "Alerte sur échéance option"),
            buildColumn("gestionDocument", "Gestion document", "Alerte sur gestion document"),
            buildColumn("signaturesClients", "Signatures clients", "Alerte sur signatures clients"),
            buildColumn("aSignerEiffage", "A signer Eiffage", "Alerte sur à signer Eiffage"),
            buildColumn("signerEiffage", "Signé Eiffage", "Alerte sur signé Eiffage"),
            buildColumn("modifierContact", "Modifier Contact", "Alerte sur modification contact"),
            buildColumn("messageInstantane", "Message instantané", "Alerte sur message instantané"),
        ];

    };

    _getFarItems = () => {
        return [{
            key: "nombreEnregistrement",
            name: !!this.state.items && this.state.items.length > 0 ? this.state.items.length - 1 : 0
        }];
    };

    _onDismiss = () => {
        this.setState({ ...FicheMandatAlerte.defaultState });
        this.props.onDismiss();
    };

    _onOpen = () => {
        this._chargementDonnees();
    };

    _onRenderDetailsHeader = (props, defaultRender) => {

        const defaultHeaderHeight = 32;
        const customHeaderHeight = defaultHeaderHeight * 2;
        let detailsHeaderStyles = {
            root: {
                height: `${customHeaderHeight}px`,
                selectors: { ".ms-DetailsHeader-cell": { height: `${customHeaderHeight}px` } }
            },
        };

        const onRenderColumnHeaderTooltip = (tooltipHostProps, dr) => {
            const index = tooltipHostProps.children._owner.pendingProps.columnIndex - 1;
            let styles = { root: { top: "unset" } };
            if (index > 0) {
                styles.root.lineHeight = "1.2rem";
                styles.root.paddingBottom = "5px";
                styles.root.whiteSpace = "pre-line"; // Permet un retour à la ligne dans le header

                // Décommenter les lignes ci-dessous pour orienter les entêtes du tableau à la verticale (+ ajuster customHeaderHeight)
                //styles.root.height = `${customHeaderHeight}px`;
                //styles.root.padding = "8px 0px"; // Corrige des décalages
                //styles.root.transform = "rotate(180deg)"; // Permet une lecture verticale
                //styles.root.writingMode = "vertical-rl"; // Permet une lecture verticale
            }
            return <TooltipHost {...tooltipHostProps} styles={styles} />;
        };

        return <Sticky stickyPosition={StickyPositionType.Header} isScrollSynced>
            <DetailsHeader
                {...props}
                onRenderColumnHeaderTooltip={onRenderColumnHeaderTooltip}
                styles={detailsHeaderStyles}
            />
        </Sticky>;

    };

    _onRenderRow = (props) => {
        // Stylisation de la première ligne
        if (!props) return null;
        const styles = props.itemIndex === 0
            ? { root: { backgroundColor: '#c8c8c8' } }
            : {};
        return <DetailsRow {...props} styles={styles} />;
    };

    _toggleAlerte = (idOperation, idAlerte, estActivee) => {
        const estPremiereLigne = idOperation === 0;
        if (estPremiereLigne) {
            if (estActivee) this._enableAll(idAlerte);
            else this._disableAll(idAlerte);
        }
        else {
            if (estActivee) this._enableOne(idOperation, idAlerte);
            else this._disableOne(idOperation, idAlerte);
        }
    };

    render = () => {

        const { isOpen } = this.props;

        return <EUIPanel
            headerText="Gérer les alertes"
            isOpen={isOpen}
            onDismiss={this._onDismiss}
            onOpen={this._onOpen}
            styles={{ content: { height: "calc(100% - 32px)" } }} // CommandBar height = 32px
            type={PanelType.extraLarge}
        >
            {this.state.enCoursDeTraitement ? <ProgressIndicatorChargement label={this.state.messageEnCoursTraitement} /> : null}

            <CommandBar
                ariaLabel={'Utiliser les flèches droite et gauche pour naviguer'}
                farItems={this._getFarItems()}
                overflowButtonProps={{ ariaLabel: 'Plus de fonctionnalités' }}
            />

            <MessageBars
                errorMessage={this.state.errorMessage}
                warningMessage={this.state.warningMessage}
                onDismissErrorMessage={() => this.setState({ errorMessage: "" })}
                onDismissWarningMessage={() => this.setState({ warningMessage: "" })}
            />

            <div className="position-relative h-100">
                <ScrollablePane scrollbarVisibility={ScrollbarVisibility.auto}>
                    <DetailsList
                        columns={this._columns}
                        items={this.state.items}
                        onRenderDetailsHeader={this._onRenderDetailsHeader}
                        onRenderRow={this._onRenderRow}
                        selectionMode={SelectionMode.none}
                    />
                </ScrollablePane>
            </div>

        </EUIPanel>;

    };

};